import React, { useState } from "react";
import styles from "./Service.module.css";
import {
  MdManageAccounts,
  MdHandshake,
  MdStorage,
  MdWifi,
  MdSecurity,
  MdApps,
} from "react-icons/md"; // example icons

const iconMap = {
  web: <MdManageAccounts />,     // マネージドITサービス
  mobile: <MdHandshake />,       // 共同管理ITサービス
  custom: <MdStorage />,         // インフラストラクチャ管理
  api: <MdWifi />,               // ネットワーク管理
  vapt: <MdSecurity />,          // VAPT評価
  car: <MdApps />,               // アプリケーション開発
};

const categories = [
  {
    key: "web",
    title: "マネージドITサービス",
    items: [
      "DG FutureTechは、ネットワークセキュリティからクラウド、コンプライアンスまですべてを管理する完全に管理されたITサービスが必要な場合でも、クラウド移行やサイバーセキュリティ監査などの特定のプロジェクトに対するアラカルトサポートが必要な場合でも、ビジネスニーズに合わせた柔軟なITソリューションを提供します。 当社の専門チームは、お客様のシステムを安全かつ効率的に常時稼働状態に保つために、24時間365日の監視とメンテナンスを実施し、お客様が成長に集中できるようにします。法律事務所のダウンタイムの解消やサイバーセキュリティの強化から在庫システムの最新化による最高のパフォーマンスの実現まで、当社はお客様のビジネスを前進させる信頼性が高くスケーラブルなテクノロジーを提供します。",
    ],
  },
  {
    key: "mobile",
    title: "共同管理ITサービス",
    items: [
      "DG FutureTechの共同管理ITサービスモデルは、インフラストラクチャ管理、ヘルプ デスクサポート、システム最適化にわたる責任を共有することで、社内のITチームを補完し、拡張するように設計されています。パフォーマンス監視、クラウド移行、パッチ管理、ベンダー調整などのタスクは当社が担当し、お客様のチームはコア業務に集中できます。当社の多層ヘルプデスク（L1～L3）は、基本的なユーザーの問題から高度なインフラストラクチャのニーズまで、あらゆる問題に対して専門的なサポートを提供します。営業時間外のサポートの管理、新しいインフラストラクチャの展開の処理、ファイアウォールなどのコンプライアンスを重視した構成の支援など、IT運用を効率的に拡張するための専門知識と柔軟性を提供します。",
    ],
  },
  {
    key: "custom",
    title: "インフラストラクチャ管理",
    items: [
      "DG FutureTechのインフラストラクチャ管理サービス（IMS）では、オンプレミス、クラウド、ハイブリッド環境のいずれの場合でも、ITシステムが常に信頼性が高く、安全で、パフォーマンスが最適化されることを保証します。プロアクティブな監視、自動メンテナンス、専門家によるサポートを組み合わせることで、ダウンタイムを最小限に抑え、運用を効率化し、コンプライアンス基準を満たします。ダウンタイムゼロのOSアップデートやソフトウェアのインストールから脆弱性管理やパフォーマンスチューニングまで、当社はさまざまな業界の企業が回復力と俊敏性を維持できるよう支援します。厳格なサイバーセキュリティのニーズを持つ金融機関をサポートする場合でも、24時間365日の稼働を必要とする医療機関をサポートする場合でも、DG FutureTechはリスクを軽減し、効率を向上し、中断なきビジネスの成長を可能にするべくカスタマイズされたソリューションを提供します。",
    ],
  },
  {
    key: "api",
    title: "ネットワーク管理",
    items: [
      "DG FutureTechは、ビジネスの接続性、セキュリティ、パフォーマンスを最高に保つように設計された、包括的なネットワーク管理サービススイートを提供します。24時間 365日の監視により、トラフィック、サーバー、アプリケーション、クラウドインフラストラクチャ、ネットワークデバイス全体の問題をプロアクティブに検出し、解決します。当社のカスタムソリューションには、高度なセキュリティ監視、パフォーマンス最適化、専門家によるコンサルティングが含まれており、今日のデジタル環境で自信を持って拡張できるよう支援します。侵入検知システムで機密性の高いフィンテックデータを保護する場合でも、ランサムウェアの脅威から企業ネットワークを保護する場合でも、DG FutureTechはネットワークの回復力と効率性を維持し、将来への備えを保証します。",
    ],
  },
  {
    key: "vapt",
    title: "VAPT評価",
    items: [
      "脆弱性評価および侵入テスト（VAPT）は、ITインフラストラクチャ、アプリケーション、ネットワーク全体の弱点を特定して検証し、潜在的な侵害を防ぐ重要なサイバーセキュリティプロセスです。VAPTは、自動化された脆弱性スキャンと実際の攻撃シミュレーションを組み合わせることで、セキュリティ体制に関する詳細な情報を提供し、コンプライアンス標準の遵守を支援します。 DG FutureTechは、ネットワークデバイス、Webおよびモバイルアプリ、クラウド環境をカバーする包括的なVAPTサービスを提供しています。また、銀行プラットフォームから社内システムに至るまで、業界をリードするツールを使用して脅威を検出、評価、修復し、防御を強化し、リスクへの露出を減らし、日々進化するサイバー脅威から機密データを保護します。",
    ],
  },
  {
    key: "car",
    title: "アプリケーション開発",
    items: [
      "DG FutureTechは、エンドツーエンドのカスタムソフトウェア開発サービスを提供し、ビジネス目標に合わせて設計されたスケーラブルで安全な高性能アプリケーションを提供します。レスポンシブWebアプリやモバイルソリューションからエンタープライズポータルやeコマースプラットフォームまで、システム分析やアーキテクチャ設計から開発、統合、シームレスな展開まで、すべてを処理します。私たちのチームは、ユーザーエクスペリエンスとビジネス効率を向上させる、直感的で多彩な機能を備えたアプリケーションの構築を専門としています。アジャイルWebポータルの開発でも、レガシーシステムの最新化でも、DG FutureTechはお客様のアイデアを、長期に亘る価値と競争優位性をもたらす強力なデジタルソリューションに変換します。",
    ],
  },
];

const ServiceSection = () => {
  const [activeTab, setActiveTab] = useState("web");

  const activeCategory = categories.find((cat) => cat.key === activeTab);

  return (
    <section className={styles.serviceSection}>
      <div className={styles.container}>
        
        <div className={styles.sidebar}>
          {categories.map((cat) => (
            <div
              key={cat.key}
              className={`${styles.tab} ${
                activeTab === cat.key ? styles.activeTab : ""
              }`}
              onClick={() => setActiveTab(cat.key)}
            >
              <span className={styles.tabIcon}>
                {iconMap[cat.key] || "📌"}
              </span>
              {cat.title}
            </div>
          ))}
        </div>
        <div className={styles.content}>
          <h2 className={styles.heading}>{activeCategory.title}</h2>
          <ul className={styles.featureList}>
            {activeCategory.items.map((item, index) => (
              <li key={index} className={styles.featureItem}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
